import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  NoticeComposerAttachmentThumb,
  type NoticeComposerUploadedFile,
} from "./NoticeComposerAttachmentThumb";

type NoticeComposerUploadedFileRowProps = {
  file: NoticeComposerUploadedFile;
  index: number;
  onRemove?: (index: number) => void;
  formatSize?: (bytes: number) => string;
  dense?: boolean;
};

export const NoticeComposerUploadedFileRow: React.FC<
  NoticeComposerUploadedFileRowProps
> = ({ file, index, onRemove, formatSize, dense = false }) => (
  <Box
    sx={{
      p: dense ? 1.5 : 2,
      borderRadius: dense ? 1.5 : 2,
      border: "1px solid",
      borderColor: "grey.200",
      backgroundColor: "grey.50",
      display: "flex",
      alignItems: "center",
      gap: dense ? 1.5 : 2,
    }}
  >
    <NoticeComposerAttachmentThumb file={file} variant="list" />
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        variant={dense ? "body2" : "body1"}
        sx={{
          fontWeight: 500,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {file.fileName}
      </Typography>
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {file.size && formatSize
          ? formatSize(file.size)
          : file.contentType}
      </Typography>
    </Box>
    {onRemove && (
      <IconButton
        size="small"
        onClick={() => onRemove(index)}
        sx={{
          color: "text.secondary",
          "&:hover": { backgroundColor: "grey.200" },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    )}
  </Box>
);

export default NoticeComposerUploadedFileRow;
